import React, { memo } from "react";
interface EndSessionModalProps {
  isVisible: boolean;
  message: string;
  onClose: () => void;
}

let toasterTimeout: ReturnType<typeof setTimeout>;

export const showToaster = (message: string) => {

  const toasterMessage = document.getElementById("toaster-message");
  const toaster = document.getElementById("toaster");

  if (toasterMessage) {
    toasterMessage.innerText = message;
  }

  if (toaster) {
    toaster.classList.add("showToaster");
  }

  if (toasterTimeout) {
    clearTimeout(toasterTimeout);
  }

  toasterTimeout = setTimeout(() => {
    toaster && toaster.classList.remove("showToaster");
  }, 3000);
};



const Toaster: React.FC<EndSessionModalProps> = () => {
  return (
      <div
        id="toaster"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          clearTimeout(toasterTimeout);
          const toaster = document.getElementById("toaster");
          toaster && toaster.classList.remove("showToaster");
        }}
        className="end-session-alert"
      >
        <p id="toaster-message" className="alert-text"></p>
        <span className="icon-close"></span>
      </div>
  );
};

export default memo(Toaster);
